import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import {
  CommunityItem,
  MediaItem,
  TravelItem,
  TravelItemMinimal,
  UserItemEssentials,
} from '../../../api/models';
import {
  BookingService,
  CommunityService,
  TravelService,
} from '../../../api/services';
import {
  ActivatedRoute,
  NavigationStart,
  Params,
  Router,
} from '@angular/router';
import {
  addDays,
  endOfYesterday,
  isAfter,
  isBefore,
  isEqual,
  isWithinInterval,
  max,
  startOfDay,
  startOfToday,
  subDays,
} from 'date-fns';
import { AuthService } from '../../../guards/services/auth.service';
import { environment } from '../../../../environments/environment';
import { SlugifyPipe } from '../../../shared/pipes/slugify.pipe';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { ModalShareOnSocialsComponent } from '../../../shared/modals/modal-share-on-socials/modal-share-on-socials.component';
import { enumAssignmentStatus } from '../../../shared/utils/enum-assignment-request';
import { enumBookingStatus } from '../../../shared/utils/enum-booking-status';
import { Location } from '@angular/common';
import { ModalLoginComponent } from '../../../modal-login/modal-login.component';

@Component({
  selector: 'app-travel-page',
  templateUrl: './travel-page.component.html',
  styleUrl: './travel-page.component.scss',
})
export class TravelPageComponent {
  items: MenuItem[] | undefined;
  showTravelProgram = false;
  responsiveOptions: any[] | undefined;
  suggested_travels: TravelItemMinimal[] = [];
  travelMenuIndicator?: any;
  travel?: TravelItem;
  dates: string[] = [];
  displayBasic = false;
  insuranceTextDialog = false;
  environmentMediaUrl = environment.mediaUrl;
  isInFavs = false;
  travel_id?: number;
  today = new Date().toISOString();
  travelers: UserItemEssentials[] = [];
  limit = 5;
  skip = 0;
  totalRecords = 0;
  shareOnSocialRef: DynamicDialogRef | undefined;
  loading = false;
  luggage_attachment?: MediaItem;
  cancellation_attachment?: MediaItem;
  enumAssignmentStatus = enumAssignmentStatus;
  cheapestPackagePrice?: number;

  showButtons: boolean = false;
  canJoinByCommunity = false;

  // modalCanBeRegistered: boolean = false; // per modale
  termsAndConditions: boolean = false; // per modale
  visibility_metadata?: CommunityItem[];
  activeIndexSelected: number | undefined = undefined;
  activeIndexImg: number = 0;
  myCommunities?: CommunityItem[];
  travelCommunities: CommunityItem[] = [];
  showCompleteBooking = false;

  constructor(
    private title: Title,
    private travelService: TravelService,
    private ar: ActivatedRoute,
    private router: Router,
    public auth: AuthService,
    private messageService: MessageService,
    private slugifyPipe: SlugifyPipe,
    private bookingService: BookingService,
    public dialogService: DialogService,
    private communityService: CommunityService,
    private location: Location,
    private meta: Meta,
    private confirmationService: ConfirmationService,
  ) {}

  ngOnInit() {
    this.ar.params.subscribe((p: Params) => {
      if (p) {
        if (p['iso']) {
          this.travel_id = p['id'];
        } else if (p['my_travel_id']) {
          this.travel_id = p['my_travel_id'];
        } else if (p['my_fav_id']) {
          this.travel_id = p['my_fav_id'];
        }

        this.getOne();
      }
      if (this.auth.isLogged()) {
        this.auth.getMyself();
        if (this.auth.user.value!.favs!.includes(Number(this.travel_id))) {
          this.isInFavs = true;
        } else {
          this.isInFavs = false;
        }
      }
    });

    this.responsiveOptions = [
      {
        breakpoint: '1399px',
        numVisible: 3,
        numScroll: 1,
      },
      {
        breakpoint: '1199px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '991px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '767px',
        numVisible: 1,
        numScroll: 1,
      },
    ];
  }
  usersLength(c: CommunityItem) {
    return (c.users.length - 6).toString();
  }
  openGallery(index: number) {
    this.activeIndexImg = index;
    this.displayBasic = true;
  }
  getOne() {
    this.loading = true;
    this.travelService
      .travelControllerGetTravel({ id: this.travel_id! })
      .subscribe({
        next: (res) => {
          this.travel = res.data; //inverto le img caricate dal BE cosi da mostrare sempre la prima selezionata

          if (this.travel.gmg_finalized_on && this.auth.isLogged()) {
            this.bookingService
              .bookingControllerMyBookings({
                travel_id: this.travel.id,
                limit: 100,
                skip: 0,
              })
              .subscribe((res) => {
                this.showCompleteBooking = (res.data?.list ?? []).some(
                  (b) =>
                    !b.gmg_adh_confirmed &&
                    b.status.id !== enumBookingStatus.REFUNDED &&
                    b.status.id !== enumBookingStatus.PENDING_REFUND &&
                    b.created_on < this.travel!.gmg_finalized_on!,
                );
              });
          }

          if (this.travel?.visibility.id === 4) {
            this.travelCommunities = this.travel
              .visibility_metadata as CommunityItem[];
            if (this.auth.isLogged()) {
              this.getMyCommunities();
            }
            this.updateCommunityAccessStatus();
          }
          const slugifyNameTravel = this.slugifyPipe.transform(
            this.travel!.name,
          );
          this.meta.addTag({
            property: 'og:title',
            content: `${this.travel.name}`,
          });
          this.meta.addTag({
            property: 'og:description',
            content: `${this.travel.payoff}`,
          });
          if (this.travel.medias.length !== 0) {
            // console.log(this.travel.medias[0].media.path)
            if (this.travel.medias[0].media.path.includes('https://')) {
              this.meta.addTag({
                property: 'og:image',
                content: `${this.travel.medias[0].media.path}`,
              });
            } else {
              this.meta.addTag({
                property: 'og:image',
                content: `${environment.mediaUrl}/${this.travel.medias[0].media.path}`,
              });
            }
          }
          this.meta.addTag({
            property: 'og:url',
            content: `${environment.shareBaseUrl}/viaggi-di-gruppo/${
              this.travel!.countries[0].country.ISO
            }/${this.travel!.countries[0].country.name}/${
              this.travel!.id
            }/${slugifyNameTravel}`,
          });

          this.dates.push(res.data.from_date);
          this.dates.push(res.data.to_date);
          this.title.setTitle(
            'SocialTravels - Viaggio' + ' - ' + this.travel?.name,
          );
          this.setBreadcrumb();
          if (res.data.undisclosed_members_list === false) {
            this.getTravelers();
          }
          //ALLEGATI
          if (this.travel?.attachments) {
            this.luggage_attachment = this.travel.attachments.find((x) =>
              x.attachment.path.includes('luggage-insurance'),
            )?.attachment;
            this.cancellation_attachment = this.travel.attachments.find((x) =>
              x.attachment.path.includes('cancellation-insurance'),
            )?.attachment;
          }
          //PRICE
          if (
            this.travel?.price_packages &&
            this.travel?.price_packages.length > 0
          ) {
            const prices = this.travel.price_packages.map(
              (p) => p.price_per_person,
            );
            this.cheapestPackagePrice = Math.min(...prices);
          }

          this.ar.queryParams.subscribe((p: Params) => {
            if (p['share'] === 'on') {
              // this.openShareOnSocialsModal(false);

              const isPrivate =
                this.travel?.visibility?.id === 2 ||
                this.travel?.visibility?.id === 4;
              if (isPrivate) {
                this.openShareOnSocialsModal(true);
              } else {
                this.openShareOnSocialsModal(false);
              }
            }
          });

          this.loading = false;
        },
      });
  }

  openShareOnSocialsModal(checkInvitations = false) {
    const slugifyCountryTravel = this.slugifyPipe.transform(
      this.travel!.countries[0].country.name,
    );
    const slugifyNameTravel = this.slugifyPipe.transform(this.travel!.name);
    this.shareOnSocialRef = this.dialogService.open(
      ModalShareOnSocialsComponent,
      {
        header: 'Condividi questo viaggio con chi vuoi!',
        width: '50%',
        styleClass: 'modal-res',
        closable: true,
        data: {
          travel: this.travel,
          checkInvitations: checkInvitations,
          url: `${environment.shareBaseUrl}/viaggi-di-gruppo/${
            this.travel!.countries[0].country.ISO
          }/${slugifyCountryTravel}/${this.travel!.id}/${slugifyNameTravel}`,
        },
      },
    );
    this.shareOnSocialRef.onClose.subscribe((v) => {
      this.router.navigate([
        `/viaggi-di-gruppo/${this.travel!.countries[0].country.ISO}/${
          this.travel!.countries[0].country.name
        }/${this.travel!.id}/${slugifyNameTravel}`,
      ]);
    });
  }

  setBreadcrumb() {
    this.ar.params.subscribe((p: Params) => {
      if (p) {
        if (p['iso']) {
          const iso = p['iso'];
          const name = p['name'];
          this.items = [
            { label: 'Homepage', routerLink: '/' },
            { label: name, routerLink: ['/viaggi-di-gruppo', iso, name] },
            { label: this.travel?.name },
          ];
        } else {
          this.items = [
            { label: 'Homepage', routerLink: '/' },
            {
              label: this.travel!.countries[0].country.name,
              routerLink: [
                '/viaggi-di-gruppo',
                this.travel!.countries[0].country.ISO,
              ],
            },
            { label: this.travel?.name },
          ];
        }
      }
    });

    this.getSuggestedTravels();
  }

  scrollTo(to: HTMLElement) {
    to.scrollIntoView({
      behavior: 'smooth',
    });
  }

  checkDatesForAlert(): boolean {
    const d = new Date(this.travel?.from_date!);
    return this.isTodayWithinRange(d);
  }

  isTodayWithinRange(depDate: Date): boolean {
    const today = startOfToday();
    // const endDate = subDays(depDate, 14); // Sottrae 14 giorni da depDate
    // const interval = { start: endDate, end: depDate };

    //PER ESCLUDERE IL GIORNO DELLA PARTENZA
    const startDate = subDays(depDate, 14); // 14 giorni prima
    const endDate = subDays(depDate, 1); // giorno prima della partenza
    const interval = { start: startDate, end: endDate };

    return isWithinInterval(today, interval);
  }

  checkForAvailability() {
    const maxMembers = this.travel?.max_members!;
    const currentMembers = this.travel?.availability?.booked!;
    return this.isGreaterThanPercentage(maxMembers, currentMembers, 60);
  }

  isGreaterThanPercentage(X: number, Y: number, percentage: number): boolean {
    if (X > Y) {
      const threshold = X * (percentage / 100);
      return Y > threshold;
    } else {
      return false;
    }
  }

  addToFavs(id: number) {
    this.travelService.travelControllerAddFavourite({ id: id }).subscribe({
      next: (res) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Preferiti',
          detail: 'Il viaggio è stato aggiunto ai preferiti.',
        });
        this.isInFavs = true;
      },
      error: (err: Error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Preferiti',
          detail: 'Impossibile aggiungere il viaggio ai preferiti.',
        });
      },
    });
  }

  removeFromFavs(id: number) {
    this.travelService.travelControllerRemoveFavourite({ id: id }).subscribe({
      next: (res) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Preferiti',
          detail: 'Il viaggio è stato rimosso dai preferiti.',
        });
        this.isInFavs = false;
      },
      error: (err: Error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Preferiti',
          detail: 'Impossibile rimuovere il viaggio dai preferiti',
        });
      },
    });
  }

  getSuggestedTravels() {
    this.travelService
      .travelControllerGetAll({
        limit: 10,
        skip: 0,
        countries: this.travel?.countries.map((x) => x.country.ISO),
      })
      .subscribe({
        next: (res) => {
          this.suggested_travels = res.data.list
            .filter((x) => x.id != this.travel_id)
            .sort((a, b) => {
              const da = new Date(a.from_date).getTime();
              const db = new Date(b.from_date).getTime();
              return da - db; // crescente → più vicina prima
            });
        },
      });
  }

  goToCheckout() {
    const slugifyName = this.slugifyPipe.transform(this.travel!.name);
    const bookingDate = new Date().toISOString(); //creo variabile per data prenotazione
    // console.log(slugifyName)
    if (!this.travel!.funding) {
      this.router.navigate([
        '/viaggi-di-gruppo/join',
        slugifyName,
        this.travel!.id,
      ]); //recupero data di prenotazione e la passo tramite queryparams
    } else {
      this.router.navigate([
        '/viaggi-di-gruppo/join-gmg',
        slugifyName,
        this.travel!.id,
      ]);
    }
  }

  goToRegister() {
    this.router.navigate(['/login'], {
      queryParams: { back_to_url: this.router.url },
    });
  }

  goToDonate() {
    const slugifyName = this.slugifyPipe.transform(this.travel!.name);
    this.router.navigate([
      '/viaggi-di-gruppo/join-donate',
      slugifyName,
      this.travel!.id,
    ]);
  }

  isTravelPast() {
    // const addedDays = addDays(this.today, 10);
    // Se mancano le date considerato disponibile
    if (!this.travel?.from_date || !this.travel?.to_date) {
      return false;
    } else {
      return (
        isBefore(this.travel?.to_date, this.today) ||
        (this.travel.booking_deadline &&
          (isBefore(this.travel.booking_deadline, this.today) ||
            isEqual(this.travel.booking_deadline, this.today)))
      );
    }
    //Se le date del viaggio sono nel passato NON disponibile
    // if (this.travel?.from_date && this.travel?.to_date < this.today) {
    //   return false;
    // }
    // //Se la partenza del viaggio è nei prossimi 10 giorni
    // else if (this.travel!.from_date < addedDays.toISOString()) {
    //   return true;
    // }

    // return false;
  }

  isPaymentAvailable() {
    const today = new Date();
    const nextMonth = addDays(today, 31);
    if (this.travel!.from_date < nextMonth.toISOString()) {
      return false;
    } else {
      return true;
    }
  }

  getTravelers() {
    this.bookingService
      .bookingControllerTravelTravelers({
        limit: this.limit,
        skip: this.skip,
        travel_id: this.travel?.id!,
      })
      .subscribe({
        next: (res) => {
          this.travelers = res.data.list;
          this.totalRecords = res.data.count;
        },
      });
  }

  alreadyJoined() {
    return this.travelers?.some((x) => x.id === this.auth.getUserId()) ?? false;
  }

  //alreadyJoined() {
  // if (this.travelers.find((x) => x.id === this.auth.getUserId())) {
  //   return true;
  // } else {
  //   return false;
  // }
  //   return false;
  // }

  loadMoreTravelers() {
    this.limit += this.limit;
    this.getTravelers();
  }

  goTo(where?: string) {
    const slugifyNameTravel = this.slugifyPipe.transform(this.travel!.name);
    if (where) {
      if (where === '/community') {
        const user = this.auth.getUser();

        if (user) {
          // Utente loggato vai alla pagina community
          // this.router.navigate(['/community']);
          return this.goToCommunity();
        } else {
          // Utente NON loggato apri login
          this.dialogService.open(ModalLoginComponent, {
            showHeader: false,
            width: '30vw',
            modal: true,
            breakpoints: {
              '960px': '40vw',
              '640px': '90vw',
            },
            styleClass: 'transparent-dialog',
            draggable: false,
            transitionOptions: '400ms cubic-bezier(0.34, 1.56, 0.64, 1)',
          });
        }

        return;
      }

      if (where === '/guest') {
        this.router.navigate([
          `/viaggi-di-gruppo/join-guest/${slugifyNameTravel}/${
            this.travel!.id
          }`,
        ]);
      } else {
        if (this.travel && this.travel.countries.length > 0) {
          sessionStorage.setItem(
            'book_item_redirect',
            `/viaggi-di-gruppo/${this.travel.countries[0].country.ISO}/${this.travel.countries[0].country.name}/${this.travel.id}/${slugifyNameTravel}`,
          );
          this.dialogService.open(ModalLoginComponent, {
            showHeader: false,
            width: '30vw',
            modal: true,
            breakpoints: {
              '960px': '40vw',
              '640px': '90vw',
            },
            styleClass: 'transparent-dialog',
            draggable: false,
            transitionOptions: '400ms cubic-bezier(0.34, 1.56, 0.64, 1)',
          });
        }
      }
    } else {
      const slugifyNamePlayer = this.slugifyPipe.transform(
        this.travel!.player.name,
      );
      this.router.navigate(['/business', slugifyNamePlayer]);
    }
  }

  showOptionalLogin() {
    const gotoWithoutLogin =
      '/viaggi-di-gruppo/join-donate/' +
      this.slugifyPipe.transform(this.travel!.name) +
      `/${this.travel!.id}`;
    this.dialogService.open(ModalLoginComponent, {
      showHeader: false,
      width: '30vw',
      modal: true,
      data: { gotoWithoutLogin },
      breakpoints: {
        '960px': '40vw',
        '640px': '90vw',
      },
      styleClass: 'transparent-dialog',
      draggable: false,
      transitionOptions: '400ms cubic-bezier(0.34, 1.56, 0.64, 1)',
    });
  }

  getTravel_metadata(i: number) {
    let travel_metadata;
    if (this.travel?.medias && this.travel.medias.length > 0) {
      if (this.travel.medias[i].media.metadata) {
        travel_metadata = this.travel.medias[i].media.metadata;
      }
    }
    if (travel_metadata) {
      return travel_metadata as any;
    } else {
      return;
    }
  }
  getMyCommunities() {
    this.communityService.communityControllerGetJoined().subscribe({
      next: (res) => {
        this.myCommunities = res.data.list;
        this.canJoinByCommunity = this.hasCommunityAccess();
        this.updateCommunityAccessStatus();
      },
    });
  }
  // hasCommunityAccess() {
  //   if (!this.visibility_metadata || !this.myCommunities) return false;
  //   //id delle communities del viaggio
  //   const communityID = this.visibility_metadata.map((c) => c.id);
  //   //id delle mie communities
  //   const myCommunitiesID = this.myCommunities.map((c) => c.id);
  //   //controllo se c'è  almeno un id corrispondente (true)
  //   return myCommunitiesID.some((id) => communityID.includes(id));
  // }
  hasCommunityAccess() {
    if (!this.travelCommunities || !this.myCommunities) return false;

    const travelIDs = this.travelCommunities.map((c) => c.id);
    const myIDs = this.myCommunities.map((c) => c.id);

    return myIDs.some((id) => travelIDs.includes(id));
  }

  // updateCommunityAccessStatus() {
  //   if (!this.visibility_metadata || !this.myCommunities) return;

  //   this.canJoinByCommunity = this.hasCommunityAccess(); //chiamo la funzione per la verifica dell id e  aggiorno true o false la variabile
  // }
  updateCommunityAccessStatus() {
    if (!this.travelCommunities || !this.myCommunities) return;
    this.canJoinByCommunity = this.hasCommunityAccess();
  }

  goToCommunity() {
    if (!this.travelCommunities || this.travelCommunities.length === 0) return;

    const ids = this.travelCommunities.map((c) => c.id);

    this.router.navigate(['/community'], {
      queryParams: {
        ids: ids.join(','),
        returnUrl: this.router.url,
      },
    });
  }
}
